import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Flex,
  Heading,
  Link as ChakraLink,
  Container,
  useColorMode,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Text,
} from "@chakra-ui/react";
import ColorModeToggle from "./ColorModeToggle";
import useUser from "../hooks/useUser";
import { useTranslation } from "react-i18next";

const Header = () => {
  const location = useLocation();
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const { user, loading } = useUser();
  const accessToken = localStorage.getItem("access_token");
  const { t, i18n } = useTranslation();

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/login");
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Box
      as="header"
      bg={colorMode === "dark" ? "gray.700" : "white"}
      boxShadow="sm"
      py={4}
    >
      <Container maxW="container.xl">
        <Flex align="center" justify="space-between">
          <ChakraLink as={Link} to="/" _hover={{ textDecoration: "none" }}>
            <Heading
              as="h1"
              size="lg"
              color={colorMode === "dark" ? "white" : "blue.600"}
              _hover={{ color: colorMode === "dark" ? "blue.300" : "blue.500" }}
            >
              KeyMakr
            </Heading>
          </ChakraLink>
          <Flex gap={8} align="center">
            <ChakraLink
              as={Link}
              to="/users"
              color={
                location.pathname === "/users"
                  ? colorMode === "dark"
                    ? "blue.300"
                    : "blue.600"
                  : colorMode === "dark"
                  ? "gray.300"
                  : "gray.600"
              }
              fontWeight="medium"
              _hover={{ color: colorMode === "dark" ? "blue.300" : "blue.600" }}
            >
              {t("users")}
            </ChakraLink>
            {accessToken && !loading ? (
              <Menu>
                <MenuButton
                  as={Button}
                  variant="ghost"
                  rightIcon={
                    <Avatar
                      size="sm"
                      name={user?.username}
                      bg={colorMode === "dark" ? "blue.500" : "blue.400"}
                    />
                  }
                >
                  <Text>{user?.username}</Text>
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={handleLogout}>{t("logout")}</MenuItem>
                </MenuList>
              </Menu>
            ) : (
              <Button
                colorScheme="blue"
                variant="solid"
                onClick={() => navigate("/login")}
                size="md"
              >
                {t("login")}
              </Button>
            )}
            <Menu>
              <MenuButton as={Button} variant="ghost">
                {t("language")}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => changeLanguage("en")}>
                  {t("english")}
                </MenuItem>
                <MenuItem onClick={() => changeLanguage("es")}>
                  {t("spanish")}
                </MenuItem>
                <MenuItem onClick={() => changeLanguage("ru")}>
                  {t("russian")}
                </MenuItem>
                <MenuItem onClick={() => changeLanguage("uk")}>
                  {t("ukrainian")}
                </MenuItem>
              </MenuList>
            </Menu>
            <ColorModeToggle />
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Header;
